module.exports = __webpack_public_path__ + "static/weight-1-7a7018fa3ad39a811f488b251f080ac4.png";